import React from "react";

const CommandModalActions = ({ isSendingCommand, isExecuteDisabled = false, onCancel, onExecute }) => (
  <div className="p-6 bg-surface-container-low/50 flex items-center justify-end space-x-3">
    <button
      type="button"
      className="px-4 py-2 text-on-surface font-semibold text-sm hover:bg-surface-container-high rounded-lg transition-colors"
      onClick={onCancel}
    >
      Cancel
    </button>
    <button
      type="button"
      className="px-6 py-2 bg-gradient-to-br from-primary to-primary-container text-white font-bold text-sm rounded-lg shadow-lg hover:shadow-primary/20 transition-all active:scale-95 disabled:opacity-60"
      onClick={onExecute}
      disabled={isSendingCommand || isExecuteDisabled}
    >
      {isSendingCommand ? "SENDING..." : "EXECUTE BROADCAST"}
    </button>
  </div>
);

export default CommandModalActions;
